
import React, { useState,useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import PromotionsHeader from './promotions_header.js';

import PromotionsActive from './promotions_active.js';


import PromoHistory from './promo_history.js';



const Promotions = ({  }) => {

    const [selection, setSelection] = useState("promotions_active");


  


  


  return (

    <>
    <div className="col-10">
      <PromotionsHeader setSelection={setSelection} />
    
      {selection === "promotions_active" && <PromotionsActive />}
      {selection === "promotions_history" && <PromoHistory />}
      

    </div>
    </>


  );
};

export default Promotions;





